import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import ConnectAccount from "./ConnectAccount";
import CreateCampaign from "./CreateCampaign";

export default function LeadsEmptyPlaceholder() {
  const { accounts_count: accountsCount } = useSelectedWorkspaceContext();
  const hasAccount = accountsCount > 0;

  return hasAccount ? <CreateCampaign /> : <ConnectAccount />;
}
